<div class="qrcode-container">
  <img [src]="qrCodeUrl" alt="QR Code" class="qr-image">
  <div class="row container mx-auto justify-content-center mt-4">
    @if (isCopyable) {
      <button mat-button color="primary" class="mb-2" (click)="copyLink()">
        {{ "generic.buttons.copy-link" | translate }}
      </button>
    }
    <button matButton="filled"
      color="primary" (click)="downloadQRCode()">Download QR-Code
    </button>
    @if (isClosable) {
      <button mat-button color="primary" class="my-2" (click)="closed.emit()">
        {{ "generic.buttons.close" | translate }}
      </button>
    }
  </div>
</div>
